import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
// import { BrowserModule } from '@angular/platform-browser';
// import { CommonModule } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { LoginService } from '../../services/login.service';
import { ActivatedRoute, Router } from '@angular/router';
import { stringify } from 'querystring';
import { ThrowStmt } from '@angular/compiler';
import { UserValidationChild } from '../../models/UserModel';

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.css']

})

export class AuthenticationComponent implements OnInit {
  [x: string]: any;

  public showMe: boolean = true;
  loginForm: FormGroup;
  errorMsg: string;
  displayEmailPasswordChangeRequest: boolean = true;
  clients: object;
  displayFirstLogin: boolean;
  displayLogin: boolean = true;
  display: boolean;
  fieldTextType: boolean;
  username : any ;
  showResetPassScreen : boolean;
  enableforgotlogin : boolean =false;

  displayForgotPassword :boolean =false;

@Input() displayLoginscreen  ;
  @Output() displayHeader: EventEmitter<any> = new EventEmitter();
  @Output() displayForgotPass: EventEmitter<any> = new EventEmitter();
  @Output() userName : EventEmitter<any> = new EventEmitter();
  displayClientSelection: boolean;
  NoIntervenant: any;
  public userDetails : UserValidationChild;
   
  constructor(private translate: TranslateService,
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private _router: Router,
    private route: ActivatedRoute
    ) {
      this.userDetails = new UserValidationChild()
  }

  ngOnInit(): void {
    
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
      sessionStorage.removeItem("ClientName");
      sessionStorage.removeItem("ClientNo");
      sessionStorage.removeItem("Year");
sessionStorage.removeItem("SavedDeclarationCachedData");
      if(sessionStorage.getItem("checktoReload") == "true"){
// location.reload();
sessionStorage.setItem("checktoReload","false");
    }else{
      var checktoReload = "false";
      sessionStorage.setItem("checktoReload",checktoReload);
    }
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  

  Forgotpasswordfn()
  {
     this.displayForgotPass.emit(true);
     this.displayLogin = false;
     this.userName.emit(this.username);
  }

  AuthenticateUser() {
    if (this.loginForm.controls.username.value !== (null || '') && this.loginForm.controls.password.value !== (null || '')) {
      this.userDetails.UserName= this.loginForm.controls.username.value;
      this.userDetails.Password =this.loginForm.controls.password.value;
     this.loginService.IsValidateUser(this.userDetails).subscribe(
        
        //Use this for Mock Login Data
       // this.loginService.getRescults().subscribe(  
        (data) => {
          //Display errors when login is failed
          if (data.Status !== "Valid" ) {
            if (data.Error == "login_blocked") {
              //Displays when user enters >5 times wrong password
              this.errorMsg = "Login_blocked_184";
            } else if (data.Error == "IncorrectPassword") {
              //Displays when user enters wrong password
              this.errorMsg = "login_or_password_unknown_182";
              
            } else if (data.Error == "IncorrectPasswordWarning") {
              //Displays when user enters <=5 times wrong password
              this.errorMsg = "login_will_be_blocked_183";
            }
            else  
            {
              //Display when something went wrong like Username invalid
              this.errorMsg = "Login_InvalidUsername_183";
            }
            
            this.display = false;
          }
          else {   
            var currentlang = sessionStorage.getItem("currentlang")
            sessionStorage.clear();
            sessionStorage.setItem("currentlang", currentlang);
            sessionStorage.setItem("token", data.Token);
            if(data.UserName != null && data.NoIntervenant != null){
              this.NoIntervenant = (data.UserName).substring(3,data.UserName.length);
              var AFF_Check = data.NoIntervenant.slice(data.NoIntervenant.length - 3)
                              }
            sessionStorage.setItem("NoIntervenant",this.NoIntervenant);
            sessionStorage.setItem("AFF_Check",AFF_Check);
            sessionStorage.setItem('Email', data.Email);
            if (data.ClientsData) {
              //Passing data to ClientSelection Component
              this.clients = data.ClientsData;
            }
            if (data.Error == 'login_NewUser' || data.LbSta=='EMAIL VALIDATION PENDING' || ( data.LbSta =='FINAL' && data.IsChangeEmailPassword)) {
              sessionStorage.setItem('IdUsr', data.IDUser);
              sessionStorage.setItem('UN', this.loginForm.get('username').value);
              sessionStorage.setItem('PWD', this.loginForm.get('password').value);              
              sessionStorage.setItem('MAIL', data.Email);
              sessionStorage.setItem("ClientsData",JSON.stringify(data.ClientsData));
              sessionStorage.setItem("Status",data.LbSta);

              this.displayFirstLogin = true;
               this.displayLogin  = false;
               this.display = false;
               this.displayHeader.emit(false);
            }

         else{
          this.display = true;
          this.displayClientSelection = true;
          this.showMe = false;
         }
            
            this.errorMsg = "";
          }
        },
        (err) => {
          this.errorMsg = "login_or_password_unknown_182";
        }
      );
    } else {
      //Displays when user enters Empty username or password
      this.errorMsg = "Login_missing_186";
    }
  }
    onDisplayLogin(checkLogin){
      this.displayLogin= checkLogin;
      this.display = true;
      this.displayClientSelection = false;
      this.displayFirstLogin = false; 
    }
    // resetpassword()
    // {
    //   this.router.navigateByUrl('/Forgot-Login');
    // }


}
